import { render } from "./ButtonsTop.vue?vue&type=template&id=ebd3309e&scoped=true"
import script from "./ButtonsTop.vue?vue&type=script&lang=js"
export * from "./ButtonsTop.vue?vue&type=script&lang=js"

import "./ButtonsTop.vue?vue&type=style&index=0&id=ebd3309e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd3309e"]])

export default __exports__